// <head> metadata for SolutionsDurableWeb3WorkflowsPage (https://www.dbos.dev/solutions/durable-web3-workflows).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: '[August] Web3 Copy',
    },
    {
      property: 'og:title',
      content: '[August] Web3 Copy',
    },
    {
      name: 'twitter:title',
      content: '[August] Web3 Copy',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/solutions/durable-web3-workflows',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
